module.exports = __webpack_public_path__ + "static/media/mail-line.4a3f48ff.svg";